import { render } from "./OrderExtraChargedNotifications.vue?vue&type=template&id=44144a1a"
import script from "./OrderExtraChargedNotifications.vue?vue&type=script&lang=js"
export * from "./OrderExtraChargedNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__